<template>
  <Teleport to="body">
    <Transition name="confirm">
      <ConfirmDialogPanel v-if="current" :request="current" @confirm="acceptConfirm" @cancel="cancelConfirm" />
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm';
import ConfirmDialogPanel from './ConfirmDialogPanel.vue';

const { current, acceptConfirm, cancelConfirm } = useConfirm();
</script>

<style scoped>
.confirm-enter-active,
.confirm-leave-active {
  transition: opacity 0.15s ease;
}
.confirm-enter-from,
.confirm-leave-to {
  opacity: 0;
}
</style>
